import { DOMAIN_ASSETS } from '#app/config/domain-assets'
import { type DomainConfig } from '#app/config/domains'

export const MetaTags = ({
	title,
	description,
	domainConfig,
	url,
	canonicalUrl,
}: {
	title: string
	description?: string
	domainConfig?: DomainConfig
	url?: string
	canonicalUrl?: string
}) => {
	const siteName = domainConfig?.siteName || 'Iconited'
	const assets = domainConfig
		? DOMAIN_ASSETS[domainConfig.domainKey]
		: DOMAIN_ASSETS.iconited
	const siteUrl =
		url || (domainConfig?.domain ? `https://${domainConfig.domain}` : '')
	const ogImageUrl = assets.ogImage
		? siteUrl
			? `${siteUrl}${assets.ogImage}`
			: assets.ogImage
		: ''

	return (
		<>
			<title>{title}</title>
			{canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
			{description && <meta name="description" content={description} />}
			<meta property="og:type" content="website" />
			<meta property="og:locale" content="en_US" />
			<meta property="og:title" content={title} />
			{description && <meta property="og:description" content={description} />}
			{siteUrl && <meta property="og:url" content={siteUrl} />}
			<meta property="og:site_name" content={siteName} />
			{ogImageUrl && (
				<>
					<meta property="og:image" content={ogImageUrl} />
					<meta property="og:image:width" content="1280" />
					<meta property="og:image:height" content="720" />
					<meta property="og:image:type" content="image/png" />
				</>
			)}
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content={title} />
			{description && <meta name="twitter:description" content={description} />}
			{ogImageUrl && (
				<>
					<meta name="twitter:image" content={ogImageUrl} />
					<meta name="twitter:image:width" content="1280" />
					<meta name="twitter:image:height" content="720" />
					<meta name="twitter:image:alt" content={title} />
				</>
			)}
		</>
	)
}
